import { Icon, Link, LinkProps, Text } from '@chakra-ui/react'
import { WhatsappLogo } from '@phosphor-icons/react'

interface WhatsAppConversionProps extends LinkProps {
  href: string
  label: string
}

export function WhatsAppConversion({ href, label, ...rest }: WhatsAppConversionProps) {
  return (
    <Link
      id="contact"
      href={href}
      rel="noopener"
      display="flex"
      alignItems="center"
      justifyContent="center"
      gap={2}
      borderRadius="6"
      color="white"
      bg="#34af23"
      px="16"
      py="3"
      fontWeight="bold"
      fontSize="2xl"
      _hover={{
        filter: 'brightness(0.9)',
        shadow: 'lg'
      }}
      title="Apoie agora pelo WhatsApp"
      {...rest}
    >
      <Icon as={WhatsappLogo} fontSize="30" />
      <Text>{label}</Text>
    </Link>
  )
}
